import { Route, useRouteMatch } from 'react-router-dom';
import SportsRoutes from '../Sports/SportsRoutes';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSocketContext } from '../../store/actions/socketAction';
import { EVENT_FILTER_OPTIONS } from '../../constants/event-filters';
import { EVENT_TYPE_ENUM } from '../../constants/enums';

const BettingContainer = () => {
    const dispatch = useDispatch();
    const match = useRouteMatch();

    const { sortType, events, total, eventType, popularEvents } = useSelector(
        state => state.sportEvents
    );
    const { seasons: outrightEvents } = useSelector(state => state.outrights);
    const socketContext = useSelector(state => state.socket.context);

    useEffect(() => {
        return () => {
            dispatch(setSocketContext({ isLive: null, events: [], betLines: [] }));
        };
    }, []);

    useEffect(() => {
        let eventIds = [];
        let isOutrights = eventType.value === EVENT_TYPE_ENUM.outright;

        if (isOutrights) {
            eventIds = outrightEvents.map(event => event.currentSeasonId);
        } else {
            if (sortType === EVENT_FILTER_OPTIONS.orders.byLeague.id) {
                eventIds = events.flatMap(season => season.events.map(event => event.id));
            } else if (
                sortType === EVENT_FILTER_OPTIONS.orders.byTime.id ||
                sortType === EVENT_FILTER_OPTIONS.orders.byMbn.id
            ) {
                eventIds = events.map(event => event.id);
            }

            const popularEventIds = popularEvents.map(event => event.id);
            eventIds = [...new Set([...eventIds, ...popularEventIds])];
        }

        const { events: currentEvents } = socketContext;

        let isEventsChanged;

        if (eventIds.length !== currentEvents.length) {
            isEventsChanged = true;
        } else {
            isEventsChanged = eventIds.some((eventId, index) => eventId !== currentEvents[index]);
        }

        if (isEventsChanged) {
            dispatch(setSocketContext({ events: eventIds, isOutrights }));
        }
    }, [total, outrightEvents, popularEvents]);

    return (
        <>
            <Route path={`${match.url}/sports`}>
                <SportsRoutes isLive={false} isESports={false} />
            </Route>
            <Route path={`${match.url}/e-sports`}>
                <SportsRoutes isLive={false} isESports={true} />
            </Route>
            <Route path={`${match.url}/live`}>
                <SportsRoutes isLive={true} isESports={false} />
            </Route>
            <Route path={`${match.url}/e-live`}>
                <SportsRoutes isLive={true} isESports={true} />
            </Route>
        </>
    );
};

export default BettingContainer;
